/** Tracks sustained quiet levels using sample timestamps in milliseconds. */
export function createSilenceDetector({
  threshold = 0.02,
  after = 10_000,
}: {
  threshold?: number;
  after?: number;
} = {}): {
  sample(level: number, now: number): boolean;
  reset(): void;
} {
  let quietSince: number | undefined;

  return {
    sample(level, now) {
      if (level >= threshold) {
        quietSince = undefined;
        return false;
      }
      quietSince ??= now;
      return now - quietSince >= after;
    },
    reset() {
      quietSince = undefined;
    },
  };
}
